<template>
  <v-list-item :key="patient.id">
    <v-list-item-icon @click="$emit('select', patient)" color="teal">
      <v-avatar color="indigo" size="40">
        <span class="white--text subtitle-1">{{ initials }}</span>
      </v-avatar>
    </v-list-item-icon>

    <v-list-item-content @click="$emit('select', patient)">
      <v-list-item-title>{{ patient.name }}</v-list-item-title>
      <v-list-item-subtitle v-if="patient.birth_date">
        {{ age }} anos
      </v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action>
      <v-btn icon @click="$emit('select', patient)">
        <v-icon color="grey">mdi-chevron-right</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'PatientCard',
  props: {
    patient: {
      type: Object,
      required: true
    }
  },
  computed: {
    initials() {
      const names = this.patient.name.split(' ')
      const first = names[0].substring(0, 1)
      const last = names[names.length - 1].substring(0, 1)
      return `${first}${last}`
    },
    age() {
      if (!this.patient.birth_date) return null
      const birth = new Date(this.patient.birth_date)
      const today = new Date()
      let age = today.getFullYear() - birth.getFullYear()
      const m = today.getMonth() - birth.getMonth()
      if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--
      return age
    }
  }
}
</script>
